import type { ZodError } from 'zod';

/** "Label: message" lines from a zod parse failure, using human field labels. */
export function zodIssueList(error: ZodError, labels: Record<string, string>): string[] {
  return error.issues.map((issue) => {
    const key = String(issue.path[0] ?? '');
    const label = labels[key] ?? key;
    return label ? `${label}: ${issue.message}` : issue.message;
  });
}
